class GameManager {
    static modalBehavior = 1;
    static toastBehavior = 2;
    static depositModalBehavior = 3;

    constructor(hasDeposited, messageType, blockingIds = [], options = {}) {
        this._hasDeposited = hasDeposited;
        this._blockingIds = {};
        for (const id of blockingIds) {
            this._blockingIds[id] = id;
        }
        this._messageType = messageType;
        this._translations = Object.assign({
            head: '',
            body: '',
        }, options?.translations || {});
        this._isOnGamePage = options?.isOnGamePage || false;
    }

    addBlockingBonus(id) {
        this._blockingIds[id] = id;
    }

    removeBlockingBonus(id) {
        if (this._blockingIds.hasOwnProperty(id)) {
            delete this._blockingIds[id];
        }
    }

    setHasDeposited(status) {
        if (typeof status != 'boolean') return;
        this._hasDeposited = status;
    }

    canPlayGame() {
        return this._hasDeposited || !Object.keys(this._blockingIds).length;
    }

    showMessage() {
        switch (this._messageType) {
            case GameManager.modalBehavior:
                const modal = $('#game-deposit-count-modal');
                modal.find('button.go-back').on('click', () => {
                    if (!this._isOnGamePage) {
                        modal.modal('hide');
                        return;
                    }

                    const goBackUrl = sessionStorage.getItem('gameGoBackUrl');
                    if (goBackUrl) {
                        window.location.href = goBackUrl;
                    } else {
                        window.history.back();
                    }
                });
                modal.modal({
                    backdrop: 'static',
                    keyboard: false
                });
                break;
            case GameManager.depositModalBehavior:
                const options = {
                    onlyCloseThroughButton: true
                };
                if (this._isOnGamePage) {
                    options.goBackOnClose = true;
                    options.goBackUrl = sessionStorage.getItem('gameGoBackUrl');
                }
                $("#make-deposit2").trigger('showDepositModal', [options, true]);
                break;
            default: // Toast
                displayNotification(this._translations.body, NOTIFICATION_TYPE_ERROR, -1);
                break;
        }
    }

    attemptOpenGameLink(e = null) {
        if (this.canPlayGame()) return true;

        this.showMessage();
        if (e && e instanceof Event) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }

        return false;
    }
}